import ApartmentTypeSelector from 'components/ApartmentTypeSelector';
import { PageContainer } from 'components/PageContainer';
import { WorldFC } from 'components/World';
import { usePageTracking } from 'hooks/usePageTracking';

const CanHoMauPage = (props) => {
  usePageTracking('interior');
  return (
    <PageContainer location={props.location}>
      <WorldFC />
      <ApartmentTypeSelector />
    </PageContainer>
  );
};

export default CanHoMauPage;
